<template>
    <div class="wrapper">
        <p class="title"> {{ $t("userAMLQuestionnaire.firstStep.labelOne") }} </p>
        <p class="message"> {{ $t("userAMLQuestionnaire.firstStep.labelTwo") }} </p>
        <template v-for="(option, index) in options">
            <input-checkbox v-if="showOption(option)"
                :key="index"
                :value="option.checked"
                :index="index"
                :text="option.text"
                :maxWidth="false"
                isWholeAreaClickable
                noBackground
                @toggleCheckBox="handleOptionChanged"
            />
        </template>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Components
import inputCheckbox from '@webapp/components/inputs/input-checkbox.vue';

// Types
import Regulation from '@shared/types/regulation';

export default {
    name: 'question-1',
    components: {
        inputCheckbox,
    },
    data() {
        return {
            options: [
                {
                    checked: false,
                    regulations: [Regulation.International],
                    text: this.$t('userAMLQuestionnaire.firstStep.optionOne'),
                    value: 'fan',
                },
                {
                    checked: false,
                    regulations: [Regulation.Usa],
                    text: this.$t('userAMLQuestionnaire.firstStep.optionEngageFan'),
                    value: 'fan',
                },
                {
                    checked: false,
                    regulations: [Regulation.Usa],
                    text: this.$t('userAMLQuestionnaire.firstStep.optionTeamPolls'),
                    value: 'fan',
                },
                {
                    checked: false,
                    regulations: [Regulation.Usa],
                    text: this.$t('userAMLQuestionnaire.firstStep.optionCheckInMatches'),
                    value: 'fan',
                },
                {
                    checked: false,
                    regulations: [Regulation.International],
                    text: this.$t('userAMLQuestionnaire.firstStep.optionTwo'),
                    value: 'trader',
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['currentRegulation']),
    },
    methods: {
        handleOptionChanged({ index }) {
            this.options[index].checked = !this.options[index].checked;

            if (this.options.every((opt) => opt.checked === false)) {
                this.$emit('in-progress');

                return;
            }
            const accountCreationReasons = this.options.filter((opt) => opt.checked).map((opt) => opt.value);
            const reasonsWithoutDuplicates = [...new Set(accountCreationReasons)];

            this.$emit('completed', {
                accountCreationReasons: reasonsWithoutDuplicates,
            });
        },
        resetStep() {
            this.options.forEach((option) => {
                option.checked = false;
            });
        },
        showOption({ regulations }) {
            return regulations.includes(this.currentRegulation);
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .title {
        font-size: 1.75rem;
        line-height: 23px;
    }

    .message {
        font-size: 1.65rem;
        line-height: 18px;
        margin: 30px 0;
        font-weight: bold;
    }

    ::v-deep {
        .checkbox {
            padding: 0;
            margin: 12px 0;
        }
    }
}
</style>